import request from '@/utils/request'
import axios from 'axios'
import { getToken } from '@/utils/auth'

const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    withCredentials: true,
    timeout: 10000
  })

export function addSave(data) {
  return request({
    url: '/businessManage/save',
    method: 'post',
    data
  })
}
/**
 * 通过id删除
 */
export function deleteProject(id) {
  return request({
    url: `/businessManage/delete/${id}`,
    method: 'delete',
  })
}
// 导入
export function importExcel(data) {
  // return post("/businessManage/importExcel",params);
  return request({
    url: '/businessManage/importExcel',
    method: 'post',
    data
  })
}

export function exportFilePost(url, fileName, params) {
  service({
    method: 'post',
    url: url,
    data: params,
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
    responseType: 'blob'
  }).then(response => {
    const blob = new Blob([response.data], {
      type: 'application/vnd.ms-excel'
    })
    const downloadElement = document.createElement('a')
    const href = window.URL.createObjectURL(blob)
    downloadElement.href = href
    downloadElement.download = fileName
    document.body.appendChild(downloadElement)
    downloadElement.click()
    document.body.removeChild(downloadElement) // 下载完成移除元素
    window.URL.revokeObjectURL(href) // 释放掉blob对象
  }).catch(error => {
    console.log(error)
  })
}
/* export function exportFile(url, fileName, params) {
  service({
    method: 'get',
    url: url,
    params,
    responseType: 'arraybuffer',
    headers: {
      Authorization: `Bearer ${getToken()}`,
      filename: 'utf-8',
      'X-Realm': process.env.VUE_APP_REALMCODE,
      'X-Ldp-Token': getToken()
    }
  }).then(res => {
    const uri = window.URL.createObjectURL(new Blob([res.data], {
      type: 'application/vnd.ms-excel'
    }))
    const link = document.createElement('a')
    link.style.display = 'none'
    link.href = uri
    document.body.appendChild(link)
    link.setAttribute('download', fileName)
    link.target = '_blank'
    link.click()
    document.body.removeChild(link) // 下载完成移除元素
    window.URL.revokeObjectURL(uri) // 释放掉blob对象
  }).catch(error => {
    console.log(error)
  })
}

export function exportFilePost(url, fileName, params) {
  service({
    method: 'post',
    url: url,
    responseType: 'arraybuffer',
    data: params,
    timeout: 50000,
    headers: {
      Authorization: `Bearer ${getToken()}`,
      filename: 'utf-8',
      'X-Realm': process.env.VUE_APP_REALMCODE,
      'X-Ldp-Token': getToken(),
    }
  }).then(res => {
    const uri = window.URL.createObjectURL(new Blob([res.data], {
      type: 'application/vnd.ms-excel'
    }))
    const link = document.createElement('a')
    link.style.display = 'none'
    link.href = uri
    document.body.appendChild(link)
    link.setAttribute('download', fileName)
    link.target = '_blank'
    link.click()
    document.body.removeChild(link) // 下载完成移除元素
    window.URL.revokeObjectURL(uri) // 释放掉blob对象
  }).catch(error => {
    console.log(error)
  })
}
 */
export function changeStatus(data, id) {
  return request({
    url: `/businessManage/changeStatus/${id}`,
    method: 'post',
    data
  })
}
